import { composeTheme } from '../../../utils/compose-theme'
import colors from '../../../tokens/v2/colors'
import fonts from '../../../tokens/fonts'
import styled from 'styled-components'

export const DdiSelector = styled.div.attrs((props) => composeTheme(props))`
  border: ${(props) => props.theme.phoneInput.borderWidth} solid
    ${(props) => props.theme.phoneInput.borderColor};
  border-bottom-left-radius: ${(props) => props.theme.phoneInput.borderRadius};
  border-right: none;
  border-top-left-radius: ${(props) => props.theme.phoneInput.borderRadius};
  margin-bottom: ${(props) => props.theme.phoneInput.marginBottom};
  padding: ${(props) => props.theme.phoneInput.padding};
`

export const Flag = styled.div.attrs((props) => composeTheme(props))`
  max-height: 2rem;

  img {
    border-radius: ${(props) => props.theme.phoneInput.flagBorderRadius};
    height: auto;
    width: 3rem;
  }
`
export const DdiContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 6.3rem;
`

export const DdiText = styled.div.attrs((props) => composeTheme(props))`
  color: ${colors.gray500};
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.phoneInput.fontSize};
  line-height: 2.4rem;
  text-align: right;
  width: 2.5rem;
`

export const DdiList = styled.div.attrs((props) => composeTheme(props))`
  border: ${(props) => props.theme.phoneInput.borderWidth} solid
    ${(props) => props.theme.phoneInput.borderColor};
  background: ${colors.white};
  max-height: 20rem;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: ${(props) => props.theme.phoneInput.padding};
  position: absolute;
  top: 7rem;
`

export const DdiOption = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(props) => props.theme.phoneInput.ddiOptionMarginBottom};
  width: 6.3rem;
`
